export default __webpack_public_path__ + "static/media/KOD0146-min.477957b6.webp";